/**
 * Context for IFS user details. Provider wraps the app so any component can access
 * ifsUser via useIfsUserContext(). Data is stored in Redux and persisted to localStorage.
 */
import { createContext, useContext } from "react";
import { useIfsUser } from "../redux/hooks/useIfsUser";

const IfsUserContext = createContext(null);

export function IfsUserProvider({ children }) {
  const value = useIfsUser();
  return (
    <IfsUserContext.Provider value={value}>
      {children}
    </IfsUserContext.Provider>
  );
}

export function useIfsUserContext() {
  const ctx = useContext(IfsUserContext);
  if (ctx == null) {
    throw new Error("useIfsUserContext must be used within IfsUserProvider");
  }
  return ctx;
}
